import { Button, Container, Input, Link, Stack, Text, useToast } from "@chakra-ui/react";
import { useNavigate, Link as ReactLink } from "react-router-dom";
import { useState, useEffect } from 'react';
import { POST } from "../../../utils/ApiRequestProvider";
import { useSelector } from "react-redux";
import { BASE_URL_REDIRECT } from "../../../config";

export default function ForgetPassword() {
    const toast = useToast();
    const navigate = useNavigate();
    const user = useSelector((state: any) => state.user.value);

    const [email, setEmail] = useState('');
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        if (user?.role) navigate("/");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    async function onSubmit() {
        try {
            if (email === "") {
                toast({
                    title: 'Please enter a valid email to continue!',
                    status: 'error',
                    isClosable: false,
                    duration: 1000,
                    position: 'top-right'
                });
                return;
            }
            setLoading(true);
            const res = await POST(
                `/api/user/password/forget?email=${email}&redirectURL=${BASE_URL_REDIRECT}/password/change`
            );

            toast({
                title: res.message,
                status: res.status,
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });

            if (res.status === 'success') {
                navigate('/login');
            }
            setLoading(false);
        } catch (err) {
            toast({
                title: 'Something Went Wrong!',
                description: 'An unexpected error occured while proceeding your request!',
                status: 'error',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
        }
    }

    return (
        <Container centerContent my={"auto"} py={32}>
            {
                <Stack spacing={3} w={'md'} boxShadow={'base'} p={6} rounded={'2xl'}>
                    <Text fontSize='2xl' color='textColor.headingColor' fontWeight={'bold'}>
                        Forgot your password?
                    </Text>
                    <Text mb={2} fontSize={'md'} color='textColor.supportingText' fontWeight={'normal'}>
                        You'll get an email with a reset link
                    </Text>
                    <Link color={'primary.400'} as={ReactLink} to={'/Login'}>
                        Back To Login?
                    </Link>
                    <Input
                        placeholder="your-email@example.com"
                        type={"text"}
                        size={"lg"}
                        p={13}
                        fontSize={"14px"}
                        fontWeight={"400"}
                        w={"full"}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <Button
                        bgGradient="linear(to-r, primary.100, primary.600)"
                        color="white"
                        rounded={"full"}
                        fontWeight={"400"}
                        fontSize={`sm`}
                        _hover={{ bgGradient: "linear(to-r, primary.100, primary.200)" }}
                        _active={{ bg: "linear(to-r, primary.500, primary.800)" }}
                        size={'md'}
                        w={"full"}
                        onClick={onSubmit}
                        isLoading={isLoading}
                    >
                        Request Reset
                    </Button>
                </Stack>
            }
        </Container>
    )
}